import { createStore } from "redux";
import Cookies from 'universal-cookie';

// Loaded from server for development we can continue loading from here..
export const initialState = {
	meta_title: "",
	meta_description: "",
	text_top_title: "",
	content: "",
	currentUser: [],
	users:[],
	usersVisible:[],
	usersTotal:0,
	showItems: 120,
	showMoreItems: 60,
	showMoreDelay: true,
	userOrder: "",
//	userOrder: typeof(localStorage.getItem('userOrder')) === 'undefined' ? JSON.parse(localStorage.getItem('userOrder') ) : "",
	isMobile: false,
	usersCompleteLoad: false,
	firstLoad: true,	// So we know when it's loaded from the server.
}

const cookies = new Cookies();

const rootReducer = (state = initialState, action) => {
	
	switch( action.type ) {

		case 'GET_TEXT':
			return {
				...state,
				meta_title: action.data.meta_title,
				meta_description: action.data.meta_description,
				text_top_title: action.data.text_top_title,
				content: action.data.content
			}
		
		//
		//	Gets the basic user list data data
		//
		case 'GET_USERS':

			return {
				...state,
				users: action.data.users,
				usersVisible: action.data.users.slice( 0, state.showItems ),
				usersTotal: action.data.total
			}
		
		//
		//	When more users are loaded usually through scrolling
		//
		case 'MORE_USERS':

			return {
				...state,
				showMoreDelay: true,
				showItems: state.showItems + state.showMoreItems,
				usersVisible: state.users.slice( 0, state.showItems )
			}
		
		case 'MORE_USERS_DONE':
			return {
				...state,
				showMoreDelay: false
			}
		
		case 'GET_ALL_USERS_RESET':
			return {
				...state,
				usersCompleteLoad: false
			}

		case 'COMPLETE_SERVER_LOAD':
			return {
				...state,
				firstLoad: false
			}

		//	On mount can correct if we want to use mobile version for example of tablet.
		/*
		case 'MOBILE_VERSION':
			return {
				...state,
				isMobile:  action.value
				//isMobile: true
			}
		*/
		// Order users by Name, Popularity...
		case 'ORDER_USERS':

			if(action.order === 'STATE' ) {
				action.order = state.userOrder;
			}

			if(action.order === 'ZtoA'){
				
				// Sort users by name case insensitive Z-A
				state.users.sort( function(a,b) {

					if (a.username.toLowerCase() > b.username.toLowerCase())	return -1;
					if (b.username.toLowerCase() > a.username.toLowerCase())	return 1;
					return 0;

				})

			} else if(action.order === 'AtoZ') {

				state.users.sort( function(a,b) {

					if (a.username.toLowerCase() > b.username.toLowerCase())	return 1;
					if (b.username.toLowerCase() > a.username.toLowerCase())	return -1;
					return 0;

				})

			} else if(action.order === 'POPULAR') {
				
				state.users.sort( function(a,b) {

					if (a.rating < b.rating)	return 1;
					if (b.rating < a.rating)	return -1;
					return 0;

				})

			} else if(action.order === 'USERS') {
				
				state.users.sort( function(a,b) {

					if (a.chatters < b.chatters)	return 1;
					if (b.chatters < a.chatters)	return -1;
					return 0;

				})

			} else if(action.order === 'OLDEST') {
				
				state.users.sort( function(a,b) {

					//	A lot of models put 99 as fake age.
					if( a.age > '90' ) return 1;
					if( b.age > '90' ) return -1;

					if (a.age < b.age)	return 1;
					if (b.age < a.age)	return -1;
					return 0;

				})

			} else if(action.order === 'YOUNGEST') {
				
				state.users.sort( function(a,b) {

					// Move age 0 to bottom -1, 1  | 1,1 | 1,-1 | -1 -1
					if( a.age == '0' ) return 1;
					if( b.age == '0' ) return 1;

					if (a.age > b.age)	return 1;
					if (b.age > a.age)	return -1;
					return 0;

				})

			}

			//	Set the current order state, also set the local storage for the page load.
			//console.log( action.order );
			//localStorage.setItem('userOrder', JSON.stringify(action.order));
			
			// save to session here incase user comes back..
			cookies.set('userOrder', action.order, { path: '/' });

			state.userOrder = action.order;
			
			//	Set the users visible state
			return {
				...state,
				usersVisible: state.users.slice( 0, state.showItems )
			}



		case 'RESET_SHOW_USERS':
			return {
				...state,
				showItems: initialState.showItems
			}


		case 'GET_CHATROOM':
			return {
				...state,
				currentUser: action.data
			}

		case 'GET_ALL_USERS_STARTED':
			return {
				...state,
				usersCompleteLoad: true
			}
			

		// Sort Users..
		default:
			return state;

	}

}


//	Create the store
export const configureStore = (initStore=null) => {
	
	//	Set default store if it wasn't passed in
	if( initStore === null ){
		initStore = initialState
	}

	const store = createStore(
		rootReducer, // root reducer
		initStore, // our initialState
	);
	
	return store;
}




// WEBPACK FOOTER //
// ./src/store.js